const formatTime = (time) => {
    const [hour, minutes] = time.split(':')
    const hourInt = parseInt(hour);
    const ampm = hourInt >= 12 ? 'PM' : 'AM';
    const hour12 = hourInt % 12 || 12;
    const newTime = `${hour12}:${minutes} ${ampm}`;
    return newTime
};

module.exports = {
    formatTime
};